import React from 'react'
import ProductStartSection from '../components/product/ProductStartSection'
import PerfectHammock from '../components/home/PerfectHammock'
import HappyCustomer from '../components/home/HappyCustomer'
import NeedOfCustomDesign from '../components/home/NeedOfCustomDesign'
import FollowOnInstagram from '../components/home/FollowOnInstagram'
import ProductsList from '../components/product/ProductsList'

const Products = () => {
  
  return (
    <>
      <ProductStartSection />
      <ProductsList />
      <PerfectHammock />
      <HappyCustomer />
      <NeedOfCustomDesign />
      <FollowOnInstagram />
    </>
  )
}

export default Products
